import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { t } from "i18next";
import { getTableColumnNames, getUserPaymentHistory, getUserWithTotalPayment } from "../../helpers/fakebackend_helper";


// Fetch Chat Report Table Column Names
export const fetchUserPaymentReportTableColumnNames = createAsyncThunk(
  "userPayments/fetchUserPaymentReportTableColumnNames",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getTableColumnNames(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);


// Fetch payment report with total payment
export const fetchUserWithTotalPayment = createAsyncThunk(
  "userPayments/fetchUserWithTotalPayment",
  async (chatReport, thunkAPI) => {
    try {
      const response = await getUserWithTotalPayment(chatReport);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Error fetching user with total payment");
    }
  }
);

// Fetch payment history
export const fetchUserPaymentHistory = createAsyncThunk(
  "userPayments/fetchUserPaymentHistory",
  async (chatReport, { rejectWithValue }) => {
    try {
      const response = await getUserPaymentHistory(chatReport);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching payment history");
    }
  }
);


// updateChatFeedbackStatus
// export const updateChatFeedbackStatus = createAsyncThunk(
//   "aiChatReport/updateChatFeedbackStatus",
//   async (feedbackData, thunkAPI) => {
//     try {
//       const response = await updateChatFeedbackStatusApi(feedbackData);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error || "Error updating chat feedback status");
//     }
//   }
// );